import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import * as dayjs from 'dayjs';
import { AppHotelService } from 'src/app/provider/app-hotel.service';
import { RequestsService } from 'src/app/provider/requests.service';
import { MenuItemModel } from 'src/app/views/models/menu-item.model';
import { RequestHeaderModel } from 'src/app/views/models/request-header.model';
import { RequestLineModel } from 'src/app/views/models/request-line.model';

@Component({
  selector: 'kt-new-request',
  templateUrl: './new-request.component.html',
  styleUrls: ['./new-request.component.scss']
})
export class NewRequestComponent implements OnInit {

  rdata = null;
  services = [];
  selectedRequest = null;

  currentIndex = 0;
  selectedReq = 0;
  quantity = 1;

  selectedOption = '';
  notes: string = null;
  roomNo: string = null;

  serviceNames: string[] = [
    'housekeeping',
    'amenities',
    'issues',
    'room_services',
    'complaint',
    'front_office'
  ];

  constructor(
    private dialog: MatDialog,
    private appHotel: AppHotelService,
    private requestService: RequestsService
    ) { }

  async ngOnInit() {
    this.appHotel.getRichData(JSON.parse(localStorage.getItem('token_form')).app_hotel_id).subscribe(data => {
      this.rdata = data;
      this.serviceNames.forEach(name => {
        if (this.rdata[`${name}`] && this.rdata[`${name}`].show) {
          this.services.push(this.rdata[`${name}`]);
        }
      });

      console.log(this.services);
    });
  }

  async close() {
    await this.dialog.closeAll();
  }

  send() {

    const serv = this.services[this.currentIndex].menu_categories[0].menu_items[0].menu_item_title_and_descriptions[this.selectedReq];

    if (serv.select_values === '') {
      this.selectedOption = '';
    }
    const rh: RequestHeaderModel = new RequestHeaderModel();
    const rl: RequestLineModel = new RequestLineModel();

    const item: MenuItemModel = this.services[this.currentIndex].menu_categories[0].menu_items[0];

    rh.menu_section_id = item.menu_section_id;
    rh.menu_section_name = JSON.parse(item.name).en;
    rh.type = JSON.parse(item.name).en;
    rh.menu_category_id = item.menu_category_id;
    rh.menu_item_id = item.id;
    rh.point = item.loyalty_max_point;
    rh.menu_category_name = JSON.parse(item.name).en;
    rh.menu_item_name = JSON.parse(item.name).en;


    const rLine: RequestLineModel = new RequestLineModel();
    rLine.type = 'Title & Description';
    rLine.no = serv.id;
    rLine.name = JSON.parse(serv.title).en;
    rLine.quantity = this.quantity;
    rLine.unit_of_measure = 'Adet';
    rLine.menu_section_id = rh.menu_section_id;
    rLine.menu_section_name = rh.menu_section_name;
    rLine.menu_category_id = rh.menu_category_id;
    rLine.menu_category_name = rh.menu_category_name;
    rLine.menu_item_id = rh.menu_item_id;
    rLine.menu_item_name = rh.menu_item_name;
    rLine.request_time = dayjs(new Date()).format('HH:mm');
    rLine.request_type_description = this.selectedOption;
    rLine.request_type_name = JSON.parse(serv.title).en;
    rh.requestlines.push(rLine);
    rLine.description = this.selectedOption;
    rLine.request_time = this.selectedOption;

    rh.hotel_id = Number(JSON.parse(localStorage.getItem('token_form')).app_hotel_id);
    rh.note = this.notes;
    rh.room_no = this.roomNo;
    rh.order_date = new Date();

    this.requestService.postRequest([rh]);

    this.close();
  }
}
